import type { TMessages } from '@/types/TMessages'

export const messages = {
  card: {
    title: {
      fieldEvaluationReport: 'Получите отчёт по оценке полей на основе спутниковых данных',
      ef_plus: 'Поле-Плюс',
      seedingRateCalc: 'Агрокалькулятор норм высева',
      agrocalculator: 'Агрокалькулятор норм удобрений',
      ef_diff: 'Поле-Дифвнесение',
      ef_expert: 'Поле-Эксперт',
      ef_scout: 'Поле-Скаутинг',
      efisZsn: 'Сопровождение, консультирование и семинары по ЕФИС ЗСН',
      consulting: 'Агрономическое сопровождение',
      soil_landscape_survey: 'Оценка с/х земель',
      faq: 'Вопросы и ответы',
      youDo: 'Платформа для работы с внештатным сезонным персоналом',
    },
    description: {
      fieldEvaluationReport: 'Вам доступно до 5 отчётов',
      ef_plus: 'Цифровой помощник для агрономов',
      seedingRateCalc: 'Поможем рассчитать оптимальную норму высева',
      agrocalculator: 'Рассчитайте с помощью алгоритмов, сколько удобрений нужно вашим посевам',
      ef_diff: 'Вносите удобрения с учетом особенностей участков поля',
      ef_expert: 'Все инструменты для эффективного управления хозяйством в одном тарифе',
      ef_scout: 'Проводите осмотры полей по-настоящему эффективно',
      consulting: 'Поможем улучшить показатели вашего бизнеса',
      soil_landscape_survey: 'Своя методология на стыке IT-решений и экспертизы в области почвоведения и картографии',
      faq: 'Расскажем все про выращивание отличного урожая',
    },
    perYear: '/ в год',
    actions: {
      readMore: 'Подробнее',
      calculate: 'Рассчитать',
      findAnswer: 'Найти ответ',
    },
  },
} as const satisfies TMessages
